import Carousel from 'react-multi-carousel'
import NewsArticleCards from '../UI/NewsArticleCards'

export default function RelatedNews({ relatedArticles }) {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      partialVisibilityGutter: 20,
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
    },
  }

  return (
    <Carousel
      removeArrowOnDeviceType={['tablet', 'mobile']}
      arrows={true}
      responsive={responsive}
      autoPlay={true}
      autoPlaySpeed={4000}
      transitionDuration={3000}
      containerClass="carousel-container related-news-carousel"
      itemClass="related-news-slide pe-3 px-1"
      showDots={false}
      infinite={true}
      renderDotsOutside={true}
      partialVisible={true}
      className="ps-0 pb-2"
    >
      {relatedArticles.map((article) => (
        <div key={article.article_id} className="related-news-slide__inner">
          <NewsArticleCards article={article} />
        </div>
      ))}
    </Carousel>
  )
}
